import React, { FC } from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { DEMO_STAY_LISTINGS } from "data/listings";
import StartRating from "components/StartRating/StartRating";
import { Link } from "react-router-dom";
import BtnLikeIcon from "components/BtnLikeIcon/BtnLikeIcon";
import SaleOffBadge from "components/SaleOffBadge/SaleOffBadge";
import Badge from "shared/Badge/Badge";
import { StayDataType } from "data/types";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";

export interface PropertyCardHProps {
  className?: string;
  data?: StayDataType;
}

const DEMO_DATA = DEMO_STAY_LISTINGS[0];

const PropertyCardH: FC<any> = ({
  className = "",
  data = DEMO_DATA,
}) => {

  const goToDetails = () => {
  debugger;
    window.location.href = "/event/" + data.closestEventId;
  }
  const renderSliderGallery = () => {
    
    return (
      <div className="flex-shrink-0 p-3 w-full sm:w-64 ">


        {<GallerySlider
          ratioClass="aspect-w-1 aspect-h-1"
          galleryImgs={["https://mamtemoc.pszyller.workers.dev/" + data.image]}
          className="w-full h-full rounded-2xl overflow-hidden will-change-transform"
          uniqueID={`PropertyCardH_${data.id}`}
          href= "#"
          
        />}

        {/* {saleOff && (
          <SaleOffBadge className="absolute left-5 top-5 !bg-orange-500" />
        )} */}
      </div>
    );
  };

  const renderContent = () => {

    let c = new Date();
    c.setHours(0);
    c.setMinutes(0);
    c.setSeconds(0);

    if (new Date(data.closestEventDate) > c)
      return (

        <div className="flex-grow p-3 sm:pr-6 flex flex-col items-start">
          <div className="space-y-4 w-full">
            <div className="inline-flex space-x-3">

              <Badge color="green"
                name={
                  <div className="flex items-center">
                    <i className="text-sm las la-clock"></i>
                    <span className="ml-1">Odbędzie sie {new Date(data.closestEventDate).toLocaleDateString('pl-PL')}</span>
                  </div>
                }
              />

            </div>
            <div onClick={ ()=>{ goToDetails()} }  className="flex items-center space-x-2">
              {/* {isAds && <Badge name="ADS" color="green" />} */}
              <h2 className="text-lg font-medium">
                <span className="line-clamp-3">{data.title}</span>
              </h2>
            </div>
            {/* {renderTienIch()} */}
            <div className="w-14 border-b border-neutral-100 dark:border-neutral-800 "></div>
            <div className="flex w-full justify-between items-end">

              <span className="flex items-center justify-center px-3 py-2 border border-secondary rounded leading-none text-base font-medium">
                {data.closestEventPrice + ` zł`}
              </span>
              <ButtonPrimary href={"/event/" + data.closestEventId} >Więcej szczegółów</ButtonPrimary>
            </div>

          </div>
        </div>

      )
    else
      return (


        <div className="flex-grow p-3 sm:pr-6 flex flex-col items-start">
          <div className="space-y-4 w-full">
            <div className="inline-flex space-x-3">

              <Badge color="yellow"
                name={
                  <div className="flex items-center">
                    <i className="text-sm las la-clock"></i>
                    <span className="ml-1">Niezaplanowane. Proszę o kontakt.</span>
                  </div>
                }
              />

            </div>
            <div onClick={ ()=> {goToDetails()}} className="flex items-center space-x-2">
              {/* {isAds && <Badge name="ADS" color="green" />} */}
              <h2 className="text-lg font-medium capitalize">
                <span className="line-clamp-3">{data.title}</span>
              </h2>
            </div>
            {/* {renderTienIch()} */}
            <div className="flex w-full justify-between items-end">

              <span className="flex items-center justify-center px-3 py-2 border border-secondary rounded leading-none text-base font-medium">
                {data.closestEventPrice + ` zł`}
              </span>
              <ButtonSecondary href={"/contact"} >Skontaktuj się</ButtonSecondary>
            </div>
          </div>
        </div>
      );
  };

  return (
    <div
      className={`nc-PropertyCardH group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-3xl overflow-hidden hover:shadow-xl transition-shadow ${className}`}
      data-nc-id="PropertyCardH"
    >

      {/* <Link to={"/listing-experiences-detail"} className="absolute inset-0"></Link> */}
       {/* onClick= { ()=>{ window.location.href= "/event/" + data.closestEventId}} */}
      <div  className="h-full w-full flex flex-col sm:flex-row sm:items-center">
        <div onClick={ ()=>{ goToDetails() }} >
        {renderSliderGallery()}</div>
        {renderContent()}
      </div>
      <BtnLikeIcon
        colorClass={` bg-neutral-100 dark:bg-neutral-700 hover:bg-neutral-200 hover:bg-opacity-70 text-neutral-6000 dark:text-neutral-400`}
        isLiked={false}
        className="absolute right-5 top-5 sm:right-3 sm:top-3 "
      />
    </div>
  );
};

export default PropertyCardH;
